import { render, staticRenderFns } from "./ADRClassButton.vue?vue&type=template&id=28f6cce6"
import script from "./ADRClassButton.vue?vue&type=script&lang=js"
export * from "./ADRClassButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports